import { ISearchResult } from 'types/income';
import { loaders } from './search.loaders';
import { SearchResult } from './search.types';

const convertSearchResult = (result: ISearchResult): SearchResult => {
  return {
    entity: result.entityType,
    entityId: result.entityId,
    description: result.description,
    benefitCategory: result.benefitPlanType,
  };
};

const convertSearchResults = (results: ISearchResult[]): SearchResult[] => {
  return results.map(convertSearchResult);
};

export const converters = {
  getSearchResults: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getSearchResults>>) => {
    const items = convertSearchResults(data.searchedResults);

    return {
      items,
      total: items.length,
    };
  },
};
